import React from "react";
import {ReactComponent as TrashCan} from "../../../assets/media_icons/trash.svg";
import "./MediaPlayer.css";

const MediaPlayer = ({
    time = "",
    progress = 0,
    step = .1,
    minValue = 0,
    maxValue = 100,
    disabled = false,
    displayDiscardButton = false,
    onClickDiscard = () => {},
    onChangeSeekBar = () => {},
    leftElement = null,
}) => {
    
    const handleSeek = (e) => {
        onChangeSeekBar(e.target.value)
    }

    return (
        <div className="media-player">
            {!displayDiscardButton && leftElement }
            {displayDiscardButton &&
            <button disabled={disabled} className="media-player-trash" onClick={onClickDiscard}>
                <TrashCan width={30} height={30} />
            </button>}
            {/* seek slider */}
            <div className="media-player-seek-slider-container">
                <input 
                    className="media-player-seek-slider" 
                    type="range" 
                    name="seek-slider" 
                    id="seek-slider"
                    min={minValue}
                    max={maxValue}
                    step={step}
                    value={progress}
                    onChange={handleSeek}
                />
            </div>
            {/* time */}
            <span className="media-player-time">{time}</span>
        </div>
    )
}

export default MediaPlayer;